import httpClient from '@/shared/http-auth-data-client';

const getEmailStages = () => httpClient.get('/EmailStages');
const postEmailStage = (data) => httpClient.post('/EmailStages', data);
const getEmailStagById = (StageId) => httpClient.get(`/EmailStages/${StageId}`);

const getJobEvents = () => httpClient.get('/JobEvents');
const getJobEventById = (JobId) => httpClient.get(`/JobEvents/${JobId}`);
const postJobEvent = (data) => httpClient.post('/JobEvents', data);

const getOutageSettings = () => httpClient.get('/OutageSettings');
const putOutageSetting = (data) => httpClient.put('/OutageSettings', data);

export {
  getEmailStages,
  postEmailStage,
  getEmailStagById,
  getJobEvents,
  getJobEventById,
  postJobEvent,
  getOutageSettings,
  putOutageSetting,
};
